// extracted by mini-css-extract-plugin
export default {"container":"Resources_container__FJG+t","header":"Resources_header__PEE1K","backButton":"Resources_backButton__cmSBv"};